$(document).ready(function () {
  function showAddedToCartPopup(product, price) {
    // Construct the popup content using product details from the response
    var thumbUrl = theme.Shopify.formatImage(product.image, "300x"); // Adjust image size if needed
    var productTitle = product.product_title; // Fallback in case product title is not available
    var imgAlt = product.featured_image.alt; // Image alt text fallback
    var variantHtml = ""; // Adjust variant details if needed
    var $priceElem = price;
    if ($priceElem.length) {
      variantHtml += `<p class="cart-product__content__price">${$priceElem}</p>`;
    }

    if (
      product.selling_plan_allocation &&
      product.selling_plan_allocation.selling_plan.name
    ) {
      variantHtml += `<p class="cart-product__content__meta">${product.selling_plan_allocation.selling_plan.name}</p>`;
    }
    if (product.options_with_values && product.options_with_values.length) {
      for (let i = 0; i < product.options_with_values.length; i++) {
        let option = product.options_with_values[i];
        if (option.name !== "Title" && option.value !== "Default Title") {
          variantHtml += `<p class="cart-product__content__meta">${option.name}: ${option.value}</p>`;
        }
      }
    }

    let offset = 25;
    const nav = theme.Nav();
    if (nav.bar.getPositionSetting() !== "inline") {
      offset = nav.bar.height();
    } // Adjust based on your theme's navigation bar offset

    const modalHtml = `
    <div id="added-to-cart" class="theme-modal theme-modal--small" role="dialog" aria-modal="true" aria-labelledby="added-to-cart-title">
      <div class="inner" style="top:${offset}px">
        <a href="#" data-modal-close="" class="modal-close">×</a>
        <h4 id="added-to-cart-title">
          <svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 0h24v24H0z" fill="none"></path><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"></path>
          </svg>
          Added to cart
        </h4>
        <div class="cart-product">
          <div class="cart-product__image">
            <img src="${thumbUrl}" alt="${imgAlt}"/>
          </div>
          <div class="cart-product__content">
            <p class="cart-product__content__title">${productTitle}</p>
            ${variantHtml}
          </div>
        </div>
        <p class="links" style="display: flex;">
          <a href="/cart" class="button alt">View cart</a>
          <a href="/checkout" class="button button--checkout" [data-cc-checkout-button]="">Checkout</a>
        </p>
      </div>
    </div>`;

    // Show the modal
    showThemeModal(modalHtml, "added-to-cart", null);
  }
  $(document).on("submit", ".collection-product-purchase-form", function (e) {
    e.preventDefault(); // Prevent the default form submission behavior

    var $form = $(this);
    var $formPrice = $(this).attr("data-product-price");
    var $formTitle = $(this).attr("data-product-title");
    var formData = $form.serialize(); // Get the form data
    var addToCartUrl = "/cart/add.js"; // Shopify AJAX endpoint

    // Disable the button and show "Adding..."
    var $btn = $form.find("button[type='submit']");
    $btn.attr("disabled", "disabled").text("Adding...");

    // Make the AJAX request to Shopify
    $.ajax({
      type: "POST",
      url: addToCartUrl,
      data: formData,
      dataType: "json",
      success: function (response) {
        console.log("Item added to cart:", response);
        $(".links.site-control__inner a.cart")
          .find("div")
          .text(
            parseInt(
              $(".links.site-control__inner a.cart").find("div").text()
            ) + 1
          );
        // Show the popup with the product details
        showAddedToCartPopup(response, $formPrice);

        // Reset button text after success
        $btn.removeAttr("disabled").text("Add to Cart");
      },
      error: function (error) {
        // Reset button text in case of error
        $btn.removeAttr("disabled").text("Add to Cart");
        // Show an error alert
        alert("You can't add more " + $formTitle + " to the cart.");
      },
    });
  });
});
